export default __webpack_public_path__ + "static/media/640_dummy2016-fotograf01-de.ab41391e.png";